export default (client) => ({
  get(filterParams) {
    return client.request({
      method: 'get',
      url: '/reports/get',
      params: { ...filterParams },
    });
  },
});
